import {
  anchorDefinition,
  mergeObjectSchemas,
  questionGoToRuleDefinition,
  questionGoToRules,
} from '../../poll/questions/questionSchemaFields';
import { logicContainerDefinition, logicRuleDefinition, topLevelLogicRules } from '../../poll/questions/schemaFields';

export {
  questionAudio,
  questionAuth,
  questionAutoNext,
  questionAutoCommit,
  questionAwardAmount,
  questionFixedRandomizeAnswers,
  questionHasAnswerCountLimit,
  questionHasAward,
  questionHasAwardMultiple,
  questionHasCorrectAnswer,
  questionHasGratitude,
  questionHasHints,
  questionHasNotApplicable,
  questionHasOthers,
  questionHideNotSelectedAnswers,
  questionRandomizeAnswers,
  questionRatingMaximum,
  questionRatingMinimum,
  questionRequiresAnswer,
  questionVideo,
  questionSkipIfOnlySystemAnswers,
  questionRatingStarsPreset,
  questionRatingDigitsPreset,
} from '../../poll/questions/questionSchemaFields';

export function createQuestionSchema(...schemas: any[] /* fixme */) {
  return {
    type: 'object',
    properties: {
      id: { type: 'string' },
      setId: {
        type: 'string',
        description:
          'Идентификатор сета, к которому принадлежит вопрос. Если у вопроса есть groupId, то setId нужно брать из группы',
      },
      ...anchorDefinition,
      data: mergeObjectSchemas(
        {
          type: 'object',
          properties: {
            text: { type: 'string' },
            ...questionGoToRules,
            ...topLevelLogicRules,
          },
          required: ['text', 'type', 'logicRules'],
          unevaluatedProperties: false,
        },
        ...schemas,
      ),
    },
    additionalProperties: false,
    required: ['id', 'data'],
    definitions: {
      ...questionGoToRuleDefinition,
      ...logicRuleDefinition,
      ...logicContainerDefinition,
    },
  };
}
